import { styled } from '@mui/material';

const StyledBlur = styled('div')({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '150%',
  zIndex: 5,
  inset: 'auto 0 0 0',
  pointerEvents: 'none',
  '&::before': {
    content: '""',
    zIndex: 1,
    backdropFilter: 'blur(0.5px)',
    mask: `linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 12.5%,
      rgba(0, 0, 0, 1) 25%,
      rgba(0, 0, 0, 0) 37.5%
    )`,
  },
  '&::after': {
    content: '""',
    zIndex: 8,
    backdropFilter: 'blur(64px)',
    mask: `linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 87.5%,
      rgba(0, 0, 0, 1) 100%
    )`,
  },
});

const StyledBlurElement = styled('div')<{ index: number }>(({ index }) => ({
  position: 'absolute',
  inset: 0,
  zIndex: index + 1,
  backdropFilter: `blur(${Math.pow(2, index - 1)}px)`,
  mask: `linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) ${12.5 * index}%,
    rgba(0, 0, 0, 1) ${12.5 * (index + 1)}%,
    rgba(0, 0, 0, 1) ${12.5 * (index + 2)}%
    ${index < 6 ? `, rgba(0, 0, 0, 0) ${12.5 * (index + 3)}%` : ''}
  )`,
}));

export const BackgroundBlur = () => (
  <StyledBlur>
    <StyledBlurElement index={1} />
    <StyledBlurElement index={2} />
    <StyledBlurElement index={3} />
    <StyledBlurElement index={4} />
    <StyledBlurElement index={5} />
    <StyledBlurElement index={6} />
  </StyledBlur>
);
